import { LookupConfiguration } from "../../../../../components/lookup/lookup.config";

export const IssueConfigs = {
    lister: <LookupConfiguration[]>[
        {
            name: 'transno',
            caption: 'Issuance No',
            width: '120px'
        },
        {
            name: 'transdate',
            caption: 'Issuance Date',
            width: '120px',
            type: 'date'
        },
        {
            name: 'LMMedia.stxt',
            caption: 'Books',
            width: '120px'
        },
        {
            name: 'LMMedia.bookno',
            caption: 'Accession No.',
            width: '120px'
        },
        {
            name: 'EREmployeeinfohdr1.firstname',
            caption: 'Issue By',
            width: '120px'
        }        
    ],
};


export const employeeConfigs = {
    lister: <LookupConfiguration[]>[
        {
            name: 'employeecode',
            caption: 'Code',
            width: '110px'
        },
        {
            name: 'firstname',
            caption: 'First Name',
            width: '180px'
        },
        {
            name: 'lastname',
            caption: 'Last Name',
            width: '180px'
        },
        {
            name: 'departmentstxt',
            caption: 'Department',
            width: '180px'
        },
        {
            name: 'designationstxt',
            caption: 'Designation',
            width: '180px'
        }
    ]
};



// WEBPACK FOOTER //
// ./src/app/shell/forms/library/transaction/Issue/issue.Config.ts